import React, { useState } from 'react';
import ColorChart from './ColorChart';
import styles from './panelStyles';

/**
 * FillEditor – slot swatches + colour chart for one SVG fill.
 * Give it a `key` that changes with the fill so the active slot resets.
 *
 * Props:
 *   colors   – string[]  current colour per slot (null while the SVG loads)
 *   onChange – (slotIndex, hex) => void
 */
export default function FillEditor({ colors, onChange }) {
    const [activeSlot, setActiveSlot] = useState(0);

    if (!colors) return <div style={styles.note}>Loading colors…</div>;
    if (colors.length === 0) return <div style={styles.note}>No editable colors.</div>;

    const active = Math.min(activeSlot, colors.length - 1);

    return (
        <div>
            <div style={styles.sectionLabel}>
                {colors.length === 1 ? 'Color' : `Color ${active + 1} of ${colors.length}`}
            </div>
            {colors.length > 1 && (
                <div style={styles.slotRow}>
                    {colors.map((c, i) => (
                        <div key={i} style={styles.slotWrap}>
                            <div
                                style={styles.slotBtn(c, active === i)}
                                onClick={() => setActiveSlot(i)}
                                title={`Color ${i + 1}: ${c}`}
                            />
                            <span style={styles.slotLabel}>{i + 1}</span>
                        </div>
                    ))}
                </div>
            )}
            <ColorChart selectedColor={colors[active]} onSelect={(hex) => onChange(active, hex)} />
        </div>
    );
}
